import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

const isDev = process.env.NODE_ENV === 'development'

// Initialize i18next with all the required configurations
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'es_US', 'en_US'],
    load: 'languageOnly',
    debug: isDev,

    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      cookieMinutes: 60 * 24 * 365, // 1 year
    },

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: isDev ? { v: Date.now() } : {}, // Cache busting in development
      allowMultiLoading: true,
    },

    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
    },

    reloadOnPrerender: isDev,
  })

// Hot reload support for development
if (isDev && module.hot) {
  module.hot.accept(
    [
      // List your translation files here
      '/public/locales/en/translation.json',
      '/public/locales/es/translation.json',
      // Add other language files as needed
    ],
    () => {
      // Reload all namespaces for all languages
      i18n.reloadResources().then(() => {
        i18n.changeLanguage(i18n.language)
      })
    }
  )
}

export default i18n
